module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_05-d1ace2a7a0154d22d0d9aaad2ffec3d0.png";